// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(/css/table.css);"]);
// Module
exports.push([module.id, "\n#filter_pop_up {\n    position: fixed;\n    width: 40%;\n    height: 50%;\n    overflow: auto;\n    margin-left: -5px;\n    top: 200px;\n    background-color: #fff;\n    border: solid 1px #ddd;\n    border-radius: 5px;\n    padding: 25px 15px;\n    left: 25%;\n    top: 25%;\n    -webkit-box-shadow: 0px 7px 5px 5px rgba(100, 100, 100, 0.35);\n            box-shadow: 0px 7px 5px 5px rgba(100, 100, 100, 0.35);\n    z-index: 10;\n    font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
